import React, { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectState } from '../../../selectors';
import ThankYouBanner from './banner';
import SetUpReturns from './set-up-returns';
import InformationYouNeed from './information-you-need';
import BottomContent from './bottom-content';
const ThankYou = () => {
    const { account: { accountId, isLoggedIn }, avataxSignup: { accountId: signupAccountId }, system: { activeFlow }, } = useSelector(selectState);
    const avataxAccountId = !isLoggedIn ? signupAccountId : accountId;
    useEffect(() => {
    }, []);
    return (React.createElement(Fragment, null,
        React.createElement(ThankYouBanner, null),
        React.createElement(SetUpReturns, { activeFlow: activeFlow, accountId: avataxAccountId }),
        React.createElement(InformationYouNeed, { activeFlow: activeFlow }),
        React.createElement(BottomContent, null)));
};
export default ThankYou;
